<template>
  <main-sidebar-item-child-title
    v-if="componentProps.itemType === 'group'"
    :title="componentProps.title"
  />
  <main-sidebar-item-child-group-collapsible
    v-else-if="componentProps.itemType === 'groupCollapsible'"
    :title="componentProps.title"
    :links="componentProps.links"
  />
  <main-sidebar-item-child-link
    v-else
    :title="componentProps.title"
    :route="componentProps.route"
    :badge="componentProps.badge"
    :right-icon="componentProps.rightIcon"
    :highlight-exact-active="componentProps.highlightExactActive"
    :small-padding="componentProps.smallPadding"
  />
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import MainSidebarItemChildTitle from '@/components/layout/mainSidebar/mainSidebarItemChild/MainSidebarItemChildTitle.vue'
import MainSidebarItemChildLink from '@/components/layout/mainSidebar/mainSidebarItemChild/MainSidebarItemChildLink.vue'
import MainSidebarItemChildGroupCollapsible from '@/components/layout/mainSidebar/mainSidebarItemChild/MainSidebarItemChildGroupCollapsible.vue'
import type {
  PageContentSidebarLink,
  PageContentSidebarSimpleItem,
} from '@/components/layout/pageContent/sidebar/types'
import type { TmIconType, TmMenuItemBadge } from '@/components/shared/types'

interface IPainSidebarItemChildTitleProps {
  itemType: 'group'
  title: string
}

interface IMainSidebarItemChildGroupCollapsibleProps {
  itemType: 'groupCollapsible'
  title: string
  links: Array<PageContentSidebarLink | PageContentSidebarSimpleItem>
}

interface IMainSidebarItemChildLinkProps {
  itemType: 'link'
  title: string
  route?: RouteLocationRaw
  badge?: TmMenuItemBadge
  rightIcon?: TmIconType
  smallPadding?: boolean
  highlightExactActive?: boolean
}

export type MainSidebarItemChildComponentProps =
  | IPainSidebarItemChildTitleProps
  | IMainSidebarItemChildGroupCollapsibleProps
  | IMainSidebarItemChildLinkProps

defineProps<{
  componentProps: MainSidebarItemChildComponentProps
}>()
</script>
